/** Pflichtwahl, sobald ein Projekt Nachweis- und Festpreispositionen hat. */
export const MIXED_PROJECT_POSITION_REQUIRED =
  "Bei Nachweis- und Festpreis-Projekten muss ausgewählt werden, ob auf Nachweis- oder Festpreispositionen gearbeitet wurde.";

/**
 * True, wenn unter den Stunden-Positionen Nachweis und Festpreis vorkommen.
 * Fehlende Preisart zählt als Festpreis (wie im Backend).
 */
export function hourBookingRequiresPreisartChoice(
  positions: Array<{ preisart?: string | null }>,
): boolean {
  let hasNachweis = false;
  let hasFestpreis = false;
  for (const position of positions) {
    if (position.preisart === "nachweis") hasNachweis = true;
    else hasFestpreis = true;
  }
  return hasNachweis && hasFestpreis;
}
